import type { FieldNode } from '@nartex/sfm-form-engine'
import { createContext, useContext } from 'react'

export const FieldsContext = createContext<FieldNode[]>([])

export function useFields(): FieldNode[] {
  return useContext(FieldsContext)
}
